export default ({ request }) => ({
    ecomAmzRepReplenishReorderTimePeriodListApi(data = {}) {
      return request({
        url: '/ecom/amz/rep/replenish/reorder/time/period/list',
        method: 'POST',
        data,
      })
    },
    ecomAmzRepReplenishReorderOperateListApi(data = {}) {
      return request({
        url: '/ecom/amz/rep/replenish/reorder/operate/list',
        method: 'POST',
        data,
      })
    },
  })
  